import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, List, Avatar, Switch, Tooltip, Dropdown, Menu } from 'antd';
import cx from 'classnames';
import {
  CheckOutlined,
  CheckCircleOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { baseColors } from '../../components/editor/colors';


export class ColorDrawer extends React.Component {

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    currentColor: PropTypes.object.isRequired,
    colorSelected: PropTypes.func.isRequired,
  };

  renderPill = (color, radius, hasBorder=false) => (
    <div style={{
      height: radius*2,
      width: radius*2,
      backgroundColor: color,
      borderRadius: radius,
    }} className={cx("mr-2", {border: hasBorder})} />
  );

  menu = (color) => (
    <Menu theme="dark">
      <Menu.Item key={color.name} onClick={() => this.props.colorSelected(color)}>
        Use color scheme "{color.name}"
      </Menu.Item>
    </Menu>
  );

  renderItem = (color) => {
    const prim = color.cols[0];
    const lightbg = color.cols[1];
    const darkbg = color.cols[3];
    const acc1 = color.cols[5];
    const acc2 = color.cols[6];
    const acc3 = color.cols[7];

    const isSelected = this.props.currentColor.name === color.name;

    return (
      <div className={cx("color__card bg-white rounded-sm shadow-sm mb-3 p-0", {
        selected: isSelected,
      })}
      >
        { isSelected ? (
          <div className="bg-primary small text-center text-white">CURRENT</div>
        ): null}

        <div className="p-2">

          <div className="mb-2">
            <Dropdown
              overlay={this.menu(color)}
              placement="bottomRight" trigger={["click"]}
            >
              <div className="color__name d-flex w-100 align-items-center text-primary justify-content-center">
                {color.name}
                <DownOutlined className="ml-2" />
              </div>
            </Dropdown>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            {this.renderPill(prim, 9)}
            <div className="text-muted small">primary</div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex">
              {this.renderPill(acc1, 9)}
              {this.renderPill(acc2, 9)}
              {this.renderPill(acc3, 9)}
            </div>
            <div className="text-muted small">accent</div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              {this.renderPill(lightbg, 9, true)}
              {this.renderPill(darkbg, 9)}
            </div>
            <div className="text-muted small">background</div>
          </div>

        </div>

      </div>
    );
  };


  render() {
    return (
      <div>
        <Drawer
          id="editor__color__drawer"
          title="Pick Colors"
          placement="right"
          className="editor__drawer color__drawer"
          closable={true}
          onClose={this.props.onClose}
          visible={this.props.visible}
          width={300}
          destroyOnClose={true}
        >
          <List
            split={false}
            itemLayout="horizontal"
            dataSource={baseColors}
            renderItem={this.renderItem}
          />
        </Drawer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/ColorDrawer.jsx